import { Route, Routes } from "react-router-dom";
import ApplicationDetailView from "../../applications/detail/ApplicationDetailView";
import AircraftInformationEditPage from "../../applications/edit/AircraftInformationEditPage";
import AirportInformationEditPage from "../../applications/edit/AirportInformationEditPage";
import ApplicantsEditPage from "../../applications/edit/ApplicantsEditPage";
import OperationsEditPage from "../../applications/edit/OperationsEditPage";
import PilotInformationEditPage from "../../applications/edit/PilotInformationEditPage";
import ApplicationsQuote from "../../applications/quote/ApplicationsQuote";
import ArchivedQuoteView from "../../renewals/view/ArchivedQuoteView";
import QuoteSearch from "../../applications/quote/QuoteSearch";
import ApplicationsSearch from "../../applications/search/ApplicationsSearch";
import PrivateAviationUser from "../../forms/privateAviation/user/PrivateAviationUser";
import StartApplication from "../../forms/privateAviation/user/startApplication/StartApplication";
import RenewalsSearch from "../../renewals/search/RenewalsSearch";
import RenewalView from "../../renewals/view/RenewalView";
import UsersList from "../../users/UsersList";
import ConfirmUser from "../ConfirmUser";
import CreatePassword from "../CreatePassword";
import ForgotPassword from "../ForgotPassword";
import HomeRedirect from "../HomeRedirect";
import Login from "../Login";
import Logout from "../Logout";
import ResultPage from "../ResultPage";
import PublicLayout from "../layouts/PublicLayout";
import AdminRoutesWrapper from "./AdminRoutesWrapper";
import PrivateRoutesWrapper from "./PrivateRoutesWrapper";
import SendRenewalEmailPage from "../../renewals/view/SendRenewalEmailPage";
import EmailTemplatePage from "../../renewals/template/EmailTemplatePage";
import Dashboard from "../../dashboard/Dashboard";

const AppRoutes = () => {
  return (
    <Routes>
      {/********
       *
       *  All Public Routes
       *
       *********/}
      <Route element={<PublicLayout />}>
        <Route path="/all-forms/private-aviation/">
          <Route path=":applicationId" element={<PrivateAviationUser />} />
          <Route index element={<StartApplication />} />
        </Route>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<CreatePassword />} />
        <Route path="/confirm-email" element={<ConfirmUser />} />
      </Route>

      {/********
       *
       *  All Private Routes
       * You must add it to privatePagesMap.js for SubHeader.js to work properly
       * You must also add it to menuItems in SideMenu.js if you want to use side menu navigation
       *
       *********/}
      <Route element={<PrivateRoutesWrapper />}>
        {/* <Route
          path="/forms/private-aviation"
          element={<PrivateAviationBroker />}
        /> */}
        <Route path="/applications/search" element={<ApplicationsSearch />} />
        <Route path="/applications/quote/">
          <Route path=":applicationId" element={<ApplicationsQuote />} />
          <Route index element={<QuoteSearch />} />
        </Route>
        <Route path="/applications/view">
          <Route path=":applicationId" element={<ApplicationDetailView />} />
        </Route>
        <Route path="/applications/edit/:applicationId">
          <Route path="applicants" element={<ApplicantsEditPage />} />
          <Route path="aircraft" element={<AircraftInformationEditPage />} />
          <Route path="operations" element={<OperationsEditPage />} />
          <Route path="airport" element={<AirportInformationEditPage />} />
          <Route path="pilot" element={<PilotInformationEditPage />} />
        </Route>
        <Route path="/renewals/search" element={<RenewalsSearch />} />
        <Route path="/renewals/view">
          <Route path=":renewalId" element={<RenewalView />} />
        </Route>
        <Route path="/renewals/send-email">
          <Route path=":renewalId" element={<SendRenewalEmailPage />} />
        </Route>
        <Route path="/renewals/email-template" element={<EmailTemplatePage />} />
        <Route path="/renewals/view-previous-quote">
          <Route path=":applicationId" element={<ArchivedQuoteView />} />
        </Route>
        <Route path="/renewals/edit/:applicationId">
          <Route path="applicants" element={<ApplicantsEditPage />} />
          <Route path="aircraft" element={<AircraftInformationEditPage />} />
          <Route path="operations" element={<OperationsEditPage />} />
          <Route path="airport" element={<AirportInformationEditPage />} />
          <Route path="pilot" element={<PilotInformationEditPage />} />
        </Route>
        <Route path="/dashboard" element={<Dashboard />} />
      </Route>
      <Route element={<AdminRoutesWrapper />}>
        <Route path="/users" element={<UsersList />} />
      </Route>
      <Route path="/logout" element={<Logout />} />
      <Route path="/" element={<HomeRedirect />} />
      <Route path="*" element={<ResultPage status={404} />} />
    </Routes>
  );
};

export default AppRoutes;
